import { Component, OnInit } from '@angular/core';
import { CommonApiService } from 'src/app/services/common-api.service';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-display-profile',
  templateUrl: './display-profile.component.html',
  styleUrls: ['./display-profile.component.scss']
})
export class DisplayProfileComponent implements OnInit {
  name: any;
  user: any;
  data: any;
  displayName: any;
  constructor(public commonApi: CommonApiService, public _router: Router) { }

  ngOnInit(): void {
    this.user = localStorage.getItem('user');
  }

  profile() {
    if(this.user) {
     
      let obj= {
        "displayName": this.name
      }
      this.commonApi.userUpdate((obj)).pipe(first()).subscribe(res=>{
       console.log(res);
       localStorage.setItem('user', JSON.stringify(res));
        this._router.navigate(['/dashboard'])        
      })
    }
  
  }

}
